import src from "IMAGE";
export default { src, width: 1140, height: 167, blurWidth: 0, blurHeight: 0};
